import type SvgProps from '~/components/icons/svg-props'

export default function DownloadIcon(props: SvgProps) {
  return (
    <svg
      id="Group_14040"
      data-name="Group 14040"
      xmlns="http://www.w3.org/2000/svg"
      width="17.341"
      height="16.283"
      viewBox="0 0 17.341 16.283"
      className={props.className}
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rectangle_2783"
            data-name="Rectangle 2783"
            width="17.341"
            height="16.283"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="1"
          />
        </clipPath>
      </defs>
      <g id="Group_14039" data-name="Group 14039" clipPath="url(#clip-path)">
        <path
          id="Path_43765"
          data-name="Path 43765"
          d="M16.163,233.728H1.178A1.168,1.168,0,0,1,0,232.572v-3.743a.546.546,0,1,1,1.092,0v3.743a.079.079,0,0,0,.086.064H16.163a.079.079,0,0,0,.086-.064v-3.743a.546.546,0,1,1,1.092,0v3.743a1.168,1.168,0,0,1-1.178,1.156"
          transform="translate(0 -217.445)"
          fill="currentColor"
          stroke="#currentColor"
          strokeWidth="1"
        />
        <path
          id="Path_43766"
          data-name="Path 43766"
          d="M.546,11.118A.546.546,0,0,1,0,10.572V.546a.546.546,0,0,1,1.092,0V10.572a.546.546,0,0,1-.546.546"
          transform="translate(9.217 11.118) rotate(180)"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"
        />
        <path
          id="Path_43767"
          data-name="Path 43767"
          d="M9.891,5.765a.544.544,0,0,1-.386-.16L5.219,1.318.932,5.6A.546.546,0,0,1,.16,4.833L4.833.16A.546.546,0,0,1,5.6.16l4.673,4.673a.546.546,0,0,1-.386.932"
          transform="translate(13.889 12.202) rotate(180)"
          fill="currentColor"
          stroke="#currentColor"
          strokeWidth="1"
        />
      </g>
    </svg>
  )
}
